/* ============================================================================
   KIVORA v6.28.0 — packs por cantidad (kv-qty-packs)

   Mejora progresiva. Sin este archivo la eleccion ya funciona: los radios se
   llaman name="quantity" y estan dentro de #kv-pdp-form, asi que el
   formulario envia la cantidad marcada.

   Este script solo hace tres cosas:
     1. Al cambiar de variante, reescribe los importes de cada opcion con los
        textos que Liquid ya formateo para esa variante (JSON en la pagina).
        Nunca calcula ni formatea dinero: no puede discrepar del servidor.
     2. Desactiva las opciones que superan el stock de la variante elegida
        (inventario con seguimiento y sin venta en negativo) y, si la opcion
        marcada deja de ser posible, vuelve a 1 unidad.
     3. Pone el total elegido dentro del boton ("Add to cart · $119.59") y
        una linea en la barra pegajosa ("Pack of 2 · $119.59").

   Orden de ejecucion: kivora-system.js (defer, en el head) define
   <kv-variants> antes que este archivo (defer, en la seccion), asi que su
   listener de 'change' en el <select name="id"> corre primero: reescribe el
   boton con data-add-label o "Sold out". Este corre despues y solo anade el
   precio si el boton NO esta desactivado.
   ========================================================================== */
(function () {
  'use strict';
  if (typeof window.customElements === 'undefined') { return; }
  if (window.customElements.get('kv-qty-packs')) { return; }

  function define(name, proto) {
    var C = function () { return Reflect.construct(HTMLElement, [], C); };
    C.prototype = Object.create(HTMLElement.prototype);
    C.prototype.constructor = C;
    Object.setPrototypeOf(C, HTMLElement);
    for (var k in proto) { if (Object.prototype.hasOwnProperty.call(proto, k)) { C.prototype[k] = proto[k]; } }
    window.customElements.define(name, C);
  }

  define('kv-qty-packs', {
    connectedCallback: function () {
      if (this._on) { return; }
      this._on = true;
      var self = this;

      var raw = this.querySelector('[data-qp-json]');
      this._data = null;
      if (raw) {
        try { this._data = JSON.parse(raw.textContent); } catch (err) { this._data = null; }
      }

      this._form = this.closest('form');
      this._select = this._form ? this._form.querySelector('[data-variant-select]') : null;
      this._btn = this._form ? this._form.querySelector('[data-add]') : null;
      this._scope = this.closest('.shopify-section') || document;
      this._sticky = this._scope.querySelector('[data-qp-sticky]');

      this.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'quantity') { self.paint(); }
      });
      if (this._select) {
        this._select.addEventListener('change', function () { self.refresh(); });
      }
      this.refresh();
    },

    inputs: function () {
      return this.querySelectorAll('input.kv-qp__input');
    },

    variantId: function () {
      if (this._select && this._select.value) { return String(this._select.value); }
      /* data-qp-variant y no data-variant: ese atributo lo reclama
         kv-variants (kivora-system.js) para sus chips y cancela el clic. */
      return this.getAttribute('data-qp-variant');
    },

    refresh: function () {
      var d = this._data ? this._data[this.variantId()] : null;
      var inputs = this.inputs();
      if (!d || !d.t) { this.paint(); return; }

      var fallback = null;
      for (var i = 0; i < inputs.length; i++) {
        var tier = d.t[i];
        if (!tier) { continue; }
        var opt = inputs[i].closest('.kv-qp__opt');
        var now = opt ? opt.querySelector('[data-qp-now]') : null;
        var was = opt ? opt.querySelector('[data-qp-was]') : null;
        var save = opt ? opt.querySelector('[data-qp-save]') : null;

        /* Tope de stock. La opcion de 1 unidad nunca se desactiva: si la
           variante esta agotada, el boton ya dice "Sold out". */
        var off = (typeof d.max === 'number' && d.max >= 0 && tier.q > d.max && tier.q > 1);
        inputs[i].disabled = off;

        if (now) { now.textContent = tier.now; }
        if (was) { was.textContent = tier.was; }
        if (save) {
          if (off) { save.textContent = 'Not enough in stock'; }
          else if (tier.p > 0) { save.textContent = 'You save ' + tier.save; }
          else { save.textContent = 'Standard price'; }
        }
        if (!off && tier.q === 1) { fallback = inputs[i]; }
      }

      /* La opcion marcada dejo de ser posible con esta variante. */
      var checked = this.querySelector('input.kv-qp__input:checked');
      if ((!checked || checked.disabled) && fallback) { fallback.checked = true; }

      this.paint();
    },

    current: function () {
      var d = this._data ? this._data[this.variantId()] : null;
      var inputs = this.inputs();
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) {
          return { q: parseInt(inputs[i].value, 10) || 1, tier: d && d.t ? d.t[i] : null };
        }
      }
      return { q: 1, tier: d && d.t ? d.t[0] : null };
    },

    paint: function () {
      var cur = this.current();
      var total = cur.tier ? cur.tier.now : '';

      /* El boton principal. kv-variants lo acaba de dejar en su etiqueta base
         o en "Sold out"; solo se toca si se puede comprar. */
      var btn = this._btn;
      if (btn && !btn.disabled) {
        var label = btn.querySelector('.kv-btn__text');
        var base = btn.getAttribute('data-add-label') || 'Add to cart';
        if (label) { label.textContent = total ? base + ' · ' + total : base; }
      }

      /* La barra pegajosa: una linea solo cuando hay pack. */
      if (this._sticky) {
        if (cur.q > 1 && total) {
          this._sticky.textContent = 'Pack of ' + cur.q + ' · ' + total;
          this._sticky.hidden = false;
        } else {
          this._sticky.textContent = '';
          this._sticky.hidden = true;
        }
      }
    },

    disconnectedCallback: function () { this._on = false; }
  });
})();